import { useSideBarMenu } from "../../utils/content/sidebar-menus";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import { ReactComponent as MenuFoldIcon } from "../../assets/MenuUnfoldIcon.svg";
import { DownOutlined } from "@ant-design/icons";
import appBarCode from "../../assets/appBarCode.png";
import DownlaodAppImage from "../../assets/download-page-image.png";
import { Divider, Drawer, Menu, Popover, Typography } from "antd";
import { Link } from "react-router-dom";
import HipaaSealImage from "../../components/HipaaSeal/HipaaSeal";

const SignInWelcome = () => {
  const { NAVBAR_INFO_MOBILE, POPUP_CONTENT, open, setOpen } = useSideBarMenu();
  return (
    <div className="bg-custom-radial flex flex-col w-full h-full justify-between">
      <div className="flex justify-center items-center w-full px-6 py-4 max-w-[1440px] lg:gap-x-40 mx-auto">
        <div className="flex justify-between gap-x-8 items-center w-full lg:w-auto">
          <Link to={"https://www.docupdate.io/"}>
            <img
              src={DocUpdateIcon}
              alt="docupdate"
              className="w-full max-w-48 object-contain mix-blend-normal lg:mr-auto"
            />
          </Link>
          <MenuFoldIcon
            onClick={() => setOpen((prevState) => !prevState)}
            className="lg:hidden text-[#565656]"
          />
          <Popover
            placement="bottom"
            title={""}
            content={POPUP_CONTENT}
            className="nav_popover"
          >
            <Link
              to={"https://www.docupdate.io/manage-preferences"}
              className="hidden link-block lg:flex justify-center items-center"
              onClick={(e) => e.preventDefault()}
            >
              What We Offer <DownOutlined className="chevron-down" />
            </Link>
          </Popover>
          <Link
            to={"https://www.docupdate.io/manage-preferences"}
            className="hidden link-block lg:flex justify-center items-center"
          >
            Manage Preferences
          </Link>
        </div>
        <div className="hidden lg:flex justify-center gap-x-4 items-center">
          <Link
            to={"/signup-new"}
            className="link-button-white flex justify-center items-center"
          >
            Sign Up
          </Link>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="link-button flex justify-center items-center"
          >
            Get the App
          </Link>
        </div>
      </div>

      <div className="mt-8 mb-4 w-full flex flex-col max-w-[1440px] px-6 py-4 mx-auto justify-center items-center gap-y-8 sm:flex-row-reverse sm:gap-x-12 sm:items-start">
        <div className="flex flex-col justify-center items-center gap-y-4 w-full max-w-[480px]">
          <Typography.Text className="font-playfair w-full font-semibold text-3xl leading-[110%] tracking-tight sm:font-bold sm:text-[52px] sm:tracking-[-2%]">
            Thank You!
          </Typography.Text>
          <Typography.Text className="font-urbanist w-full text-[25px] leading-5 align-middle sm:leading-[100%] sm:font-poppins sm:tracking-tight">
            You're all set to start using the app.
          </Typography.Text>
          <div className="flex flex-col gap-y-4 w-full">
            <Typography.Text className="mb-2 font-bold text-lg font-poppins text-left w-full leading-[157%]">
              1. Scan the QR code below to download the DocUpdate app.
            </Typography.Text>
            <Typography.Text className="font-bold text-lg font-poppins text-left w-full leading-[157%]">
              2. Log in using the email and password you just used to sign up.
              <br />
              <span>(Your email is your username.) </span>
            </Typography.Text>
          </div>
          <div className="hidden mt-4 sm:flex flex-col gap-y-4 w-full">
            <img
              src={appBarCode}
              className="ml-1 p-3 bg-white rounded-lg w-full max-w-32 app-bar-code-shadow"
            />
          </div>
        </div>
        <Link
          to={"https://docupdate.onelink.me/j4xR/desktop"}
          className="my-3 link-button flex justify-center items-center sm:hidden w-full max-w-[300px]"
        >
          Get the App
        </Link>
        <div className="min-w-[300px] w-full max-w-[415px] lg:ml-[7rem]">
          <img
            src={DownlaodAppImage}
            alt="download-image"
            className="object-contain w-full object-right"
          />
        </div>
      </div>
      <div className="mt-6 bg-[#f2fdff] flex flex-col w-full justify-center items-center">
        <div className="min-h-400px px-6 py-4 flex w-full max-w-[1080px] justify-between items-start">
          <div className="flex flex-col justify-center items-start gap-y-4 md:gap-y-6">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal"
              />
            </Link>
            <div className="flex flex-col items-start gap-y-4 md:flex-row md:gap-x-8">
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="link-block-light flex justify-center items-center"
              >
                Manage Preferences
              </Link>
              <Link
                to={"https://www.docupdate.io/#faq"}
                className="link-block-light flex justify-center items-center"
              >
                Help
              </Link>
              <Link
                to={"https://www.docupdate.io/privacy-policy/"}
                className="link-block-light flex justify-center items-center"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
          <HipaaSealImage />
        </div>
        <Divider className="w-full max-w-screen-2xl" />
        <div className="flex flex-col md:flex-row justify-between items-center w-full p-4 max-w-[1080px] gap-y-3">
          <div className="flex justify-center items-center">
            <Typography.Text className="footer-text-color">
              Copyright © 2025 DocUpdate | All Rights Reserved.
            </Typography.Text>
          </div>
          <div className="flex justify-center gap-x-8 items-center">
            <Link
              to={"https://www.docupdate.io/terms-of-service/"}
              className="link-block-lighter flex justify-center items-center"
            >
              Terms of Service
            </Link>
            <Link
              to={"https://www.docupdate.io/do-not-call-policy/"}
              className="link-block-lighter flex justify-center items-center"
            >
              DNC Policy
            </Link>
            <Link
              to={
                "https://www.docupdate.io/hipaa-business-associate-agreement/"
              }
              className="link-block-lighter flex justify-center items-center"
            >
              HIPAA Terms
            </Link>
            <Link
              to={"https://www.docupdate.io/ccpa-notice/"}
              className="link-block-lighter flex justify-center items-center"
            >
              CCPA Notice
            </Link>
          </div>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={true}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        className={`navbar_drawer flex justify-center p-[0.85rem_1.5rem] w-full`}
      >
        <div className="flex flex-col gap-y-10 w-full h-full">
          <Typography.Text className="font-playfair text-3xl text-center">
            What We Offer
          </Typography.Text>
          <Menu
            mode="inline"
            className="w-full h-full border-none flex flex-col gap-y-4 max-h-[360px]"
            items={NAVBAR_INFO_MOBILE}
            defaultSelectedKeys={["1"]}
          />
          <Link
            to={"/signup-new"}
            className="link-button-white flex justify-center items-center"
          >
            Sign Up
          </Link>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="link-button flex justify-center items-center"
          >
            Get the App
          </Link>
        </div>
      </Drawer>
    </div>
  );
};

export default SignInWelcome;
